<script>
  import { createEventDispatcher } from 'svelte';
  import Button from '@components/Button.svelte';
  import AppInviteAjax from '@ajax/app_invite';
  import Notification from '@utils/notification';
  import jQuery from 'jquery';
  import Track from '@utils/track';
  import Mixpanel from '@utils/mixpanel';

  const dispatch = createEventDispatcher();

  export let pendingUserData = {};
  export let mobile = false;
  export let convertPendingUserToActualUser;

  let letter1;
  let letter2;
  let letter3;
  let letter4;
  let letter5;

  let letter1El;
  let letter2El;
  let letter3El;
  let letter4El;
  let letter5El;

  let previousValue;

  let verifyingCode = false;
  let verifyCodeFailed;
  let showNoInviteCodeScreen = false;

  let addCodeWithPaste = function (e) {
    e.preventDefault();
    e.stopPropagation();

    let clipboardData = e.clipboardData || window.clipboardData;
    let pastedData = clipboardData.getData('Text');

    if (pastedData.length === 5) {
      letter1 = pastedData[0];
      letter2 = pastedData[1];
      letter3 = pastedData[2];
      letter4 = pastedData[3];
      letter5 = pastedData[4];

      jQuery(e.target).blur();
      verifyCode();
    }
  };

  let convertPendingUserToUserWithInvite = async function (invite) {
    try {
      let newUser = await convertPendingUserToActualUser(pendingUserData.code, invite.code, pendingUserData.name);

      dispatch('finished', {
        user: newUser,
        inviteCode: invite.code,
      });
    } catch (err) {
      if (err && err.full_errors && err.full_errors.length > 0) {
        Notification.send({
          text: err.full_errors[0],
          type: 'error',
        });
      }
    }
  };

  let fullCode = function () {
    return `${letter1}${letter2}${letter3}${letter4}${letter5}`;
  };

  let verifyCode = async function (skipped = false) {
    verifyingCode = true;
    verifyCodeFailed = undefined;

    try {
      let invite = await AppInviteAjax.get(fullCode(), {
        withErrorHandling: false,
      });

      if (!skipped) {
        Track.inviteCodeEntered();
      }

      convertPendingUserToUserWithInvite(invite);
      Mixpanel.track('user:create');
    } catch (err) {
      verifyingCode = false;
      const errorResponse = err && err.responseJSON;
      if (errorResponse && errorResponse.full_errors && errorResponse.full_errors.length > 0) {
        verifyCodeFailed = errorResponse.full_errors[0];
      } else {
        verifyCodeFailed = 'The invite code you entered was invalid';
      }
    }
  };

  let inputDataAdded = function (event, nextInput, prevInput) {
    const { value } = event.target;

    if (fullCode().length === 5) {
      verifyCode();
      return;
    }

    // This is a workaround for dealing mobile chrome does not fire "paste" event from sms auto-populate.
    if (!(letter1 && letter1.length) && value.length === 5) {
      event.clipboardData = {
        getData: () => value.trim(),
      };
      addCodeWithPaste(event);
      return;
    }

    if (event.keyCode === 8 && (previousValue != '' || previousValue)) {
      previousValue = '';
    } else if (prevInput && event.keyCode === 8) {
      prevInput.focus();
    } else if (nextInput && event.target.value.length === 1) {
      nextInput.focus();
    }
  };

  let continueFlow = async function () {
    letter1 = 's';
    letter2 = 'k';
    letter3 = 'i';
    letter4 = 'p';
    letter5 = '1';

    verifyCode({ skipped: true });
  };

  let setFocus = function (node) {
    if (!mobile && !verifyCodeFailed) {
      node.focus();
    }
  };
</script>

<style style="text/scss" lang="scss">
  .invite-code {
    margin: 60px 0 0;
    padding: 32px 20px;
    border-top: 1px solid #ececec;

    &.mobile {
      margin: 40px -20px 0 -20px;
    }

    .party-icon,
    .partying-face {
      width: 48px;
      margin-bottom: 24px;
    }

    .ui-header {
      font-size: 34px;
      line-height: 32px;
      text-align: center;
      margin-bottom: 8px;
      color: #717171;
      text-transform: uppercase;
      font-weight: 800;
    }

    .ui-subheader {
      font-size: 16px;
      line-height: 28px;
      text-align: center;
      color: #7f7f7f;
      margin-bottom: 24px;
      margin-left: auto;
      margin-right: auto;
    }

    .code-container {
      display: flex;
      flex-direction: column;
      margin-top: 24px;

      .code-container-header {
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        margin-bottom: 24px;
        color: #717171;
      }

      .code-input {
        border: 1px solid #b3b3b3;
        border-radius: 16px;
        width: 56px;
        height: 56px;
        font-size: 24px;
        color: #1c1c1c;
        text-align: center;
        -webkit-appearance: none;
        max-width: 18% !important;

        &:focus {
          outline: none;
          background: #f5f5f5;
          border: 1px solid #1c1c1c;
        }
      }

      .invite-failed {
        font-size: 16px;
        line-height: 20px;
        text-align: center;
        color: #ff5567;
        margin-top: 4px;
      }

      .verifying-code {
        i {
          font-size: 32px;
          color: #a893f9;
        }
      }
    }

    .ui-request-header {
      font-weight: bold;
      font-size: 32px;
      line-height: 40px;
      margin-bottom: 16px;
    }

    .ui-request-text {
      font-size: 18px;
      line-height: 24px;
      color: #717171;
      margin-bottom: 40px;
    }

    .ui-request-button {
      width: 100%;
      margin-left: auto;
      margin-right: auto;

      :global(button) {
        background: #7a5cfa;
      }
    }

    .ui-back-btn {
      position: absolute;
      top: 25px;
      font-size: 15px;
      line-height: 18px;
      cursor: pointer;

      .fa {
        margin-right: 10px;
        color: #d5cfea;
      }

      span {
        color: #000000;
        opacity: 0.5;
      }
    }
  }

  .mobile {
    .ui-request-header {
      font-size: 20px;
      line-height: 28px;
    }

    .ui-request-text {
      font-size: 16px;
      line-height: 24px;
    }

    .ui-subheader {
      width: 100%;
      font-weight: normal;
      font-size: 14px;
      line-height: 23px;
    }

    .code-container {
      margin-top: 40px;

      .code-container-header {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 16px;
      }
    }
  }

  .skip-waitlist-link {
    color: #896bd9;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  * :global(.has-left-icon) {
    margin-left: 4px;
  }
</style>

<div class="invite-code" class:mobile={mobile}>
  {#if showNoInviteCodeScreen}
    <div class="request-invite-container">
      <img class="partying-face" src="/images/app-invites/partying-face.png" />
      <div class="ui-header national-2-narrow">Congrats, you skipped the waitlist!</div>
      <div class="ui-request-text">You just claimed one of today's last daily invite spots.</div>
      <div class="ui-request-button">
        <Button
          class="test-congrats-next-btn"
          text={verifyingCode ? '<i class="fa fa-spinner fa-spin"></i>&nbsp;&nbsp;Working...' : 'Next'}
          on:click={continueFlow}
          disabled={verifyingCode} />
      </div>
    </div>
  {:else}
    <div class="invite-code-container">
      <img class="party-icon" src="/images/app-invites/party.svg" />
      <div class="ui-header national-2-narrow">Have an invite code?</div>
      <div class="ui-subheader" style="line-height: 24px; margin-top: 16px;">
        Earn a <span style="font-weight: bold; color: #2BAF87">10% bonus</span> on your<br />commissions if you were
        referred!
      </div>
      <div class="code-container">
        {#if verifyingCode}
          <div class="verifying-code">
            <i class="fa fa-spinner fa-spin" />
          </div>
        {:else}
          <div>
            <input
              use:setFocus
              on:focus={(event) => (previousValue = event.target.value)}
              on:input={(event) => inputDataAdded(event, letter2El, null)}
              bind:this={letter1El}
              bind:value={letter1}
              type="text"
              class="code-input"
              maxlength="5"
              on:paste={addCodeWithPaste} />
            <input
              on:focus={(event) => (previousValue = event.target.value)}
              on:keyup={(event) => inputDataAdded(event, letter3El, letter1El)}
              bind:this={letter2El}
              type="text"
              class="code-input"
              maxlength="1"
              bind:value={letter2} />
            <input
              on:focus={(event) => (previousValue = event.target.value)}
              on:keyup={(event) => inputDataAdded(event, letter4El, letter2El)}
              bind:this={letter3El}
              type="text"
              class="code-input"
              maxlength="1"
              bind:value={letter3} />
            <input
              on:focus={(event) => (previousValue = event.target.value)}
              on:keyup={(event) => inputDataAdded(event, letter5El, letter3El)}
              bind:this={letter4El}
              type="text"
              class="code-input"
              maxlength="1"
              bind:value={letter4} />
            <input
              on:focus={(event) => (previousValue = event.target.value)}
              on:keyup={(event) => inputDataAdded(event, null, letter4El)}
              bind:this={letter5El}
              type="text"
              class="code-input"
              maxlength="1"
              bind:value={letter5} />
          </div>

          {#if verifyCodeFailed}
            <div class="invite-failed">
              {verifyCodeFailed}
            </div>
          {/if}
        {/if}
      </div>
      <div
        style="margin-top: 40px; margin-bottom: 24px; width: 320px; max-width: 100%; margin-left: auto; margin-right: auto;">
        <Button
          class="skip-waitlist-link"
          disabled={verifyingCode}
          on:click={() => {
            Track.inviteCodeSkip();
            continueFlow();
          }}>Skip<span style="font-size: 16px; margin-left: 8px;">›</span></Button>
      </div>
    </div>
  {/if}
</div>
